import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'app-line-item',
  templateUrl: './line-item.component.html',
  styleUrls: ['./line-item.component.css'],
  imports: [CommonModule, TranslateModule],
})
export class LineItemComponent {
  @Output() handleClick = new EventEmitter<void>();
  @Input() option!: string;

  onClick() {
    this.handleClick.emit();
  }
}
